import { useSelector } from "react-redux";
import { handleDownloadbase64ToFile } from "@shared/components/Base64toFile";
import versionfile from "../../assets/third-party/version.json";
import { Popover } from "antd";

const Footer = ({ color = "text-gray-600" }) => {
  const {
    company_name,
    company_url,
    privacy_policy,
    terms_conditions,
    about_us,
  } = useSelector((state) => state.company_profile);

  const linkClass = `text-xs cursor-pointer hover:text-primary-600 transition-colors ${color}`;

  return (
    <footer className="flex flex-row justify-between items-center px-4 h-12 mt-auto border-t border-gray-100 bg-white">
      <span className={`text-xs ${color}`}>
        &copy; {new Date().getFullYear()} Powered by{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={company_url || "https://www.nexgensis.com/"}
          className="text-primary-600 hover:text-primary-700 hover:underline"
        >
          {company_name || "Nexgensis"}
        </a>
      </span>

      <div className="flex items-center gap-4">
        <Popover
          content={
            <div className="text-sm">
              <p><strong>Branch</strong>: {versionfile.Branch}</p>
              <p><strong>Version</strong>: {versionfile.Version}</p>
              <p><strong>Date</strong>: {versionfile.Date}</p>
            </div>
          }
          trigger="click"
        >
          <span className={linkClass}>Version</span>
        </Popover>

        {privacy_policy ? (
          <span
            className={linkClass}
            onClick={() =>
              handleDownloadbase64ToFile(
                privacy_policy?.split(",")[1],
                "Privacy-Policy"
              )
            }
          >
            Privacy Policy
          </span>
        ) : (
          <a href="#/privacy-policy" target="_blank" className={linkClass}>
            Privacy Policy
          </a>
        )}

        {terms_conditions ? (
          <span
            className={linkClass}
            onClick={() =>
              handleDownloadbase64ToFile(
                terms_conditions?.split(",")[1],
                "Terms-Conditions"
              )
            }
          >
            Terms & Conditions
          </span>
        ) : (
          <a href="#/terms-conditions" target="_blank" className={linkClass}>
            Terms & Conditions
          </a>
        )}

        {about_us ? (
          <span
            className={linkClass}
            onClick={() =>
              handleDownloadbase64ToFile(about_us?.split(",")[1], "About-Us")
            }
          >
            Contact Us
          </span>
        ) : (
          <a href="#/contact-us" target="_blank" className={linkClass}>
            Contact Us
          </a>
        )}
      </div>
    </footer>
  );
};

export default Footer;
